import { Theme } from '@mui/material';

const MuiFormHelperText = (theme: Theme) => {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            fontSize: '0.95rem',
          },
        },
      },
    },
  };
};

export default MuiFormHelperText;
